import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tooltips.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { initAuth, setAuthToken } from "./services/authService";

// Initialize authentication state
const token = localStorage.getItem('accessToken');
if (token) {
  setAuthToken(token);
}

// Initialize authentication on application startup
initAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
